import React from "react";
import { Container, Flex, useColorModeValue } from "@chakra-ui/react";
import Navbar from "../components/Navbar";
import Header from "../components/Header";
import ImageUploadComponent from "../components/ImageUploadComponent";

const ImpactedToothPA = () => {
    return (
        <>
            <Header />
            <Navbar />
            <Container
                bgColor={useColorModeValue("gray.200", "blue.900")}
                maxW="full"
                mt={0}
                centerContent
                overflow="hidden"
                py={10}
            >
                <Flex direction="column" align="center" p={4}>
                    <ImageUploadComponent 
                        apiUrl={`${process.env.REACT_APP_MOUTH_API}/detect_with_output_img/impacted_tooth_pa?threshold=0.22`} 
                        title={"ตรวจจับฟันคุด (Impacted teeth) จากภาพแบบ PA"} 
                        desc={"สามารถตรวจจับได้เฉพาะฟันคุดแบบ Partial ซึ่ที่ 38 และ 48 เท่านั้น"}
                    />
                </Flex>
            </Container>
        </>

    );
};

export default ImpactedToothPA;
